__turbopack_context__.v({
  "big": "KbooJW_big",
  "container": "KbooJW_container",
  "fields": "KbooJW_fields",
  "first": "KbooJW_first",
  "form-content": "KbooJW_form-content",
  "form-submitted": "KbooJW_form-submitted",
  "form-title": "KbooJW_form-title",
  "pixel": "KbooJW_pixel",
  "second": "KbooJW_second",
  "section": "KbooJW_section",
  "small": "KbooJW_small",
  "subtitle": "KbooJW_subtitle",
  "success-text": "KbooJW_success-text",
  "text": "KbooJW_text",
  "title": "KbooJW_title",
});
